export const sortByDateDesc = (arr, feildName) =>
  arr.sort((a, b) => new Date(b[feildName]) - new Date(a[feildName]));
